import { Switch, useRouteMatch } from 'react-router-dom';
import {
    ContactCustomFieldsRouter,
    ContactTagsRouter,
} from 'assets/js/pages/contacts/ContactsRouter';
import { ConvertContactFormDrawer } from 'assets/js/pages/contacts/ConvertContactFormDrawer';
import { CreateContactFormDrawer } from 'assets/js/pages/contacts/CreateContactFormDrawer';
import { Companies } from 'assets/js/pages/contacts/companies/Companies';
import { Company } from 'assets/js/pages/contacts/companies/Company';
import { DrawerRoute } from 'components/drawer-route';
import { Route } from 'components/router/Route';

const CompaniesRouter = () => {
    const match = useRouteMatch();

    return (
        <Switch>
            <Route path={`${match.path}/:contact_id(\\d+)`} component={Company} />
            <Route path={match.path} component={CompaniesIndexRouter} />
        </Switch>
    );
};

const CompaniesIndexRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <DrawerRoute path={`${match.path}/new`} component={CreateContactFormDrawer} />
            <DrawerRoute
                path={`${match.path}/convert/:contact_id(\\d+)`}
                component={ConvertContactFormDrawer}
            />
            <Switch>
                <Route path={`${match.path}/tags`} component={ContactTagsRouter} />
                <Route path={`${match.path}/custom-fields`} component={ContactCustomFieldsRouter} />
                <Route path={match.path} component={Companies} />
            </Switch>
        </>
    );
};

export { CompaniesRouter };
